import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

//dialog func - dragable
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
function QrList({ qrList }) {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Button onClick={handleClickOpen}>
        {qrList[0].titles[0] === "No text was Found" ||
          qrList[0].titles[0] === "Journey Id was not Found"
          ? "not found"
          : "qrList "}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          qrLists
        </DialogTitle>
        <DialogContent>
          <div className="rtscroll-bg">
            {qrList && (
              <div className="rtscroll-div">
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Time</TableCell>
                        <TableCell>QR Shopping List</TableCell>
                      </TableRow>
                    </TableHead>
                    {qrList.map((row) => (
                      <TableBody key={row.id}>
                        {row.titles.map((title, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {new Date(row.ts).toLocaleString()}
                            </TableCell>
                            <TableCell>
                              <TableCell>{title}</TableCell>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    ))}
                  </Table>
                </TableContainer>
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Exit</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default QrList;
